var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FormItem',{attrs:{"label":"活动规则","prop":"count"}},[_c('span',[_vm._v("买 1")]),_c('span',[_vm._v(" 送 1")]),_c('span',[_vm._v(" 件")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }